

























































import { Component, Prop, Watch } from 'vue-property-decorator';
import { QrcodeStream, QrcodeCapture, QrcodeDropZone } from 'vue-qrcode-reader';
import LoadingComponent from '@/components/shared/loading.component.vue';
import TagNoMatchComponent from '@/components/public/modal/tag-no-match.component.vue';
import TagIncompleteComponent from '@/components/public/modal/tag-incomplete.component.vue';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';
import { mixins } from 'vue-class-component';
import PublicGetTagMixin from '@/mixins/public-get-tag.mixin';
import AuthenticationModule from '@/store/modules/authentication.module';

@Component({
  components: {
    QrcodeStream,
    QrcodeCapture,
    QrcodeDropZone,
    LoadingComponent,
    TagNoMatchComponent,
    TagIncompleteComponent
  },
  computed: {
    bgVariant(): string {
      return this.$props.darkMode ? 'secondary' : '';
    },
    textVariant(): string {
      return this.$props.darkMode ? 'white' : '';
    }
  }
})
export default class QRCodeStreamComponent extends mixins(PublicGetTagMixin) {
  @Prop({
    default: false
  })
  public darkMode: boolean;

  public code = '';
  public cameraAccess = true;
  public showInitLoading = false;

  public get isPublicPage(): boolean {
    return this.$route.name ? this.$route.name.includes('public') : false;
  }

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public async onInit(
    capabilities: Promise<MediaTrackCapabilities>
  ): Promise<void> {
    try {
      this.showInitLoading = true;
      this.cameraAccess = true;
      await capabilities;
    } catch (error) {
      switch (error.name) {
        case 'StreamApiNotSupportedError':
          this.cameraAccess = false;
          this.$toasted.error(
            'Unfortunately this is not supported in this browser.'
          );
          break;

        case 'NotAllowedError':
          this.cameraAccess = false;
          this.$toasted.error('You need to grant camera access permisson.');
          break;

        default:
          this.$toasted.error(error.name);
          break;
      }
    } finally {
      this.showInitLoading = false;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async onDetect(fileSelection: Promise<any>) {
    try {
      const { content } = await fileSelection;
      if (content === null) {
        this.$toasted.error(
          'Sorry, no QR code was found that satisfies the given constraints.'
        );
      } else {
        this.code = content.substring(content.lastIndexOf('/') + 1);
        this.isTagRegistered();
      }
    } catch (error) {
      this.$toasted.error(error);
    }
  }

  public async isTagRegistered(): Promise<void> {
    const authModule: AuthenticationModule = getModule(
      AuthenticationModule,
      store
    );

    //The API requires the accepted terms to be sent prior to calling the [GetTagByCode]
    //We made need to update the API to address this
    await authModule.acceptTermsAction(true);
    // await registeredTagModule.isTagRegisteredAction(this.code);

    // if (!this.errorResponse && this.doesTagExist) {
    //   if (!this.doesTagExist.registered && !this.doesTagExist.completed) {
    //     this.$bvModal.show('modal-no-match');
    //   } else {
    //     this.$router.replace({
    //       name: routeName.public.viewAccess,
    //       params: {
    //         tagCode: this.code
    //       }
    //     });
    //   }
    // }
    await this.getTagByCode(this.code, this.isPublicPage);
  }
}
